import Page from 'components/layout/Page';
import JuniorsFooter from './sections/footer/JuniorsFooter';
import JuniorsHero from './sections/hero/JuniorsHero';
import JuniorsKit from './sections/kit/JuniorsKit';
import JuniorsWhy from './sections/why/JuniorsWhy';

type ContentProps = {
  content?: any[];
  links?: any[];
};

const HelpingCompaniesComponent: React.FC<ContentProps> = ({
  content,
  links
}) => {
  return (
    <Page hasScrollTop>
      <JuniorsHero />
      <JuniorsKit content={content} links={links} />
      <JuniorsWhy />
      <JuniorsFooter />
    </Page>
  );
};

export default HelpingCompaniesComponent;
